import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auctiondetailsheader',
  templateUrl: './auctiondetailsheader.component.html',
  styleUrls: ['./auctiondetailsheader.component.scss']
})
export class AuctiondetailsheaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
